.root {
  width: 100%;
  color: var(--table-color);
  border-collapse: collapse;

  & tr td {
    padding: 1rem;
    border-top: 1px solid var(--table-row-border-color);
  }

  & thead th {
    padding-bottom: 0.75rem;
    font-weight: var(--font-weight-medium);
  }

  & tr:hover td {
    background-color: var(--surface);
  }

  & tbody + thead th {
    padding-top: 2rem;
  }
}

.tight {
  & tr td,
  & tr th {
    padding: 0.75rem 0;
    border-color: var(--table-row-border-color-tight);
  }

  td + td,
  th + th {
    padding-left: 0.75rem;

    &:last-child {
      padding-right: 0.75rem;
    }
  }
}
